import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { clipping_model_editable, clipping_on } from '@features/clipping';
import edge_to_plane_perpendicular_svg from '../../../assets/img/SVG_icons/Top/editing_model/edge_to_plane_perpendicular.svg';
import { img } from '@phi/components';
import { complete_making_edges_perpendicular_to_plane, make_edges_perpendicular_to_plane } from '@frontend/uid_continuity';
import EdgeToPlanePerpendicularTooltip from './EdgeToPlanePerpendicularTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const EdgeToPlanePerpendicularIcon = edge_to_plane_perpendicular_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Perpendicular edge w.r.t. plane';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl
                || this.state.rigid_move_manipulator
                || (
                    clipping_on.value
                    && !clipping_model_editable.value
                )
                || !this.state.editing_edge_tangent_mode
                || this.state.selected_edges_count === 0;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else if (this.state.selecting_tangent_perpendicular_plane)
                complete_making_edges_perpendicular_to_plane();
            else
                make_edges_perpendicular_to_plane();
        },
    },

    render() {
        return h(BarButton, {
            onClick: this.onClick,
            tippy: 'left',
            active: this.state.selecting_tangent_perpendicular_plane,
            selected: this.state.tut_stage === 8,
            disabled: this.disabled,
            id: 'edge-to-plane-perpendicular-button',
            help: 'edge_to_plane_perpendicular',
            pro_indicator: this.subscriptions.state.subscription_status.value === 'starter',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(edge_to_plane_perpendicular_svg, this.alt),
            tooltip: EdgeToPlanePerpendicularTooltip,
        });
    },
});
